import React, { useEffect }                                    from 'react';
import { Button }                                              from "semantic-ui-react";
import { useMutation }                                         from "@apollo/react-hooks";
import { runIfFunction }                                       from "@src/util";
import { Align, CorvalProjectActivity, FuncOrAsyncFunc, Size } from "@src/types";
import { StyledContainer }                                     from "@src/views/containers";
import { ProjectActivityBulkUpdateShellFormContainerProps }    from "@src/views/pages/projects/activities/bulk/ProjectActivityBulkUpdateShell";


interface ProjectActivityBulkUpdateMenuizedFocusFormContainerProps extends ProjectActivityBulkUpdateShellFormContainerProps {
    onUpdateComplete: FuncOrAsyncFunc<[ mutatedActivitySet?: Array<CorvalProjectActivity> ], void>,
    onUpdateError: FuncOrAsyncFunc<[ e: Error ], void>,
}

const ProjectActivityBulkUpdateMenuizedFocusFormContainerDefaultProps = {
    onUpdateComplete: null,
    onUpdateError:    null,
} satisfies Partial<ProjectActivityBulkUpdateMenuizedFocusFormContainerProps>

function ProjectActivityBulkUpdateMenuizedFocusFormContainer( { children, ...p }: ProjectActivityBulkUpdateMenuizedFocusFormContainerProps ){

    const props = { ...ProjectActivityBulkUpdateMenuizedFocusFormContainerDefaultProps, ...p } as ProjectActivityBulkUpdateMenuizedFocusFormContainerProps;

    const [ mutate, mutateReq ] = useMutation( props.mutation );

    useEffect( () => {

        if( mutateReq.data ){

            props.onComplete( mutateReq.data );

            runIfFunction( props.onUpdateComplete, mutateReq.data.updateProjectActivities );
        }

    }, [ mutateReq.data ] );

    const handleMutate = async () => {

        props.onSubmit();

        try{

            const args     = await props.graphArgs(),
                  response = await mutate( args );

            if( response.errors ){

                runIfFunction( props.onError, response.errors );
                runIfFunction( props.onUpdateError, response.errors );
            }

        } catch( e ) {

            runIfFunction( props.onError, e );
        }
    }

    return (
        <>
            { children }

            <StyledContainer textAlign={ Align.CENTER } margin={ [ Size.MD, null ] }>

                <Button primary
                        type={ 'button' }
                        content={ 'Update' }
                        disabled={ props.operationDisabled }
                        loading={ props.isLoading || props.isProcessing }
                        onClick={ handleMutate }/>

            </StyledContainer>
        </>
    );
}

const ProjectActivityBulkUpdateMenuizedFocusFormContainerMemo = React.memo( ProjectActivityBulkUpdateMenuizedFocusFormContainer );

export {
    ProjectActivityBulkUpdateMenuizedFocusFormContainerMemo as ProjectActivityBulkUpdateMenuizedFocusFormContainer,
    ProjectActivityBulkUpdateMenuizedFocusFormContainerDefaultProps,
    type ProjectActivityBulkUpdateMenuizedFocusFormContainerProps,
};
